import Loading from "@@/core/components/shared/Loading/Loading";
import mixins from "@@/core/mixins/mixins";
import {
  BTooltip,
  BButton,
  BCard,
  BTable,
  BCollapse,
  BFormGroup,
  BFormInput,
  VBToggle,
  VBModal,
} from "bootstrap-vue";

export default {
  name: "Admin",
  components: {
    Loading,
    BTooltip,
    BButton,
    BCard,
    BTable,
    BCollapse,
    BFormGroup,
    BFormInput,
  },
  directives: {
    "b-toggle": VBToggle,
    "b-modal": VBModal,
  },
  mixins: [mixins],
  data() {
    return {
      url: "admin/admins",
      fields: [
        {
          key: "id",
          label: "شناسه",
        },
        {
          key: "name",
          label: "نام",
        },
        {
          key: "username",
          label: "نام کاربری",
        },
        {
          key: "email",
          label: "ایمیل",
        },
        {
          key: "mobile",
          label: "شماره تماس",
        },
        {
          key: "created_at",
          label: "تاریخ ثبت",
        },
        // {
        //   key: "edit",
        //   label: "ویرایش",
        // },
        // {
        //   key: "delete",
        //   label: "حذف",
        // },
      ],
    };
  },
  mounted() {
    this.loadItems();
  },
};
